import React from 'react'

const SearchInput = (props: any) => {
    const [searchInput, setSearchInput] = React.useState((window as any).query);

    const handleSearchInput = (event: any) => {
        const value = event?.target?.value;
        setSearchInput(value);
        props?.emitHandleSearch(value)
    }
    return (
        <div className="box position-absolute">
            <div className="container-2">
                <span className="icon">
                    <img className="search-box" src="/img/search-icon.svg" alt="" />
                </span>
                <input type="text" id="search" value={searchInput} onChange={(e) => { handleSearchInput(e) }} placeholder="Search items" />
            </div>
        </div>
    )
}
export default SearchInput; 
